<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <el-tabs v-model="activeName">
      <el-tab-pane label="考生信息审核" name="adminEdit">
        <examinee-face/>
      </el-tab-pane>
      <el-tab-pane label="评委信息审核" name="teacherEdit">
        <jury-face :activeName="activeName"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ExamineeFace from './components/examineeFace'
import JuryFace from './components/juryFace'

export default {
  name: 'admin',
  components: { ExamineeFace, JuryFace },
  props: [],
  data () {
    return {
      activeName: 'adminEdit'
    }
  },
  async created () {
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    // handleClick (tab, event) {

    // }
  }
}
</script>
